import emptyStateIcon from './assets/desktop-empty-state.svg';
import styles from './DesktopEmptyState.module.css';

type DesktopEmptyStateProps = {
  message?: string;
  className?: string;
};

const getAssetSrc = (asset: unknown) =>
  typeof asset === 'string' ? asset : (asset as { src: string }).src;

const EMPTY_STATE_ICON_SRC = getAssetSrc(emptyStateIcon);

export function DesktopEmptyState({
  message = '暂无数据',
  className,
}: DesktopEmptyStateProps) {
  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')}>
      <img
        className={styles.icon}
        src={EMPTY_STATE_ICON_SRC}
        alt=""
        aria-hidden="true"
      />
      <div className={styles.text}>{message}</div>
    </div>
  );
}
